import React from 'react';

export default function TextIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
      <title>Text</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g id="Text">
            <path
              fill="currentColor"
              d="M8.34,17H6.75V1h4.84V3a.48.48,0,1,0,1,0V.49A.48.48,0,0,0,12.07,0H.48A.48.48,0,0,0,0,.49V3a.48.48,0,0,0,.48.49A.48.48,0,0,0,1,3V1H5.8V17H4.2a.49.49,0,0,0,0,1H8.34a.49.49,0,0,0,0-1Z"
            />
            <path
              fill="currentColor"
              d="M19.52,6.94H11.24a.48.48,0,0,0-.48.49v1.7a.48.48,0,1,0,1,0V7.91h3.19V17h-.77a.49.49,0,0,0,0,1h2.48a.49.49,0,0,0,0-1h-.77V7.91H19V9.13a.48.48,0,1,0,1,0V7.43A.48.48,0,0,0,19.52,6.94Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
